export default function Intro() {
  return (
    <section className="py-20 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left — styled event photo */}
          <div className="w-full h-[460px] rounded-2xl overflow-hidden bg-gray-100 flex-shrink-0">
            <img
              src="/assets/img/41044491a894.webp"
              alt="Bespoke styled event interior"
              className="w-full h-full object-cover object-[center_20%]"
            />
          </div>

          {/* Right — text */}
          <div>
            <p className="text-teal-500 text-sm font-semibold tracking-widest uppercase mb-3">
              Full Event Styling
            </p>
            <h2 className="text-4xl font-extrabold text-gray-900 leading-snug mb-6">
              Beyond the tent. <br /> Into the extraordinary.
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Every event deserves more than just cover. Our bespoke decor service transforms your stretch tent into a fully dressed, atmospheric venue, tailored entirely to your theme, brand, and vision.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
